import React from "react";
import { Box, Button, Heading, Text, Tip } from "grommet";
import { PersonObject } from "../config/types";
import {
    selectedPersonsKeptR,
    selectedPersonsR,
} from "../recoils/selectedPersons";
import { useRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";
import { ImArrowRight } from "react-icons/im";
import { Close } from "grommet-icons";

const PersonSelectBox = (props: any) => {
    // state from recoil
    const [selectedPersons, setSelectedPersons] =
        useRecoilState(selectedPersonsR);
    const [selectedPersonsKept, setSelectedPersonsKept] =
        useRecoilState(selectedPersonsKeptR);

    let navigate = useNavigate();

    const gotoPersonPage = () => {
        if (selectedPersons.length > 0) {
            let n_person = selectedPersons.length;
            console.log("gotoPersonPage", selectedPersons);
            let id_list = selectedPersons.map((person) => person.person_id);
            let id_string = id_list.join("&");
            navigate("/person#" + id_string);
        }
    };

    const removePersonsAll = () => {
        console.log("removePersonsAll");
    };
    const addPersonsAll = () => {};
    const emptyPersonsSelected = () => {
        setSelectedPersonsKept([]);
        setSelectedPersons([]);
    };
    const removeAPerson = (person: PersonObject) => {
        // console.log("removeAPerson", person);
        let index = selectedPersons.findIndex((p) => p.person_id === person.person_id);
        let index_k = selectedPersonsKept.findIndex((p) => p.person_id === person.person_id);
        if (index >= 0) {
            let newSelectedPersons = [...selectedPersons];
            newSelectedPersons.splice(index, 1);
            setSelectedPersons(newSelectedPersons);
        }
        if (index_k >= 0) {
            let newSelectedPersonsKept = [...selectedPersonsKept];
            newSelectedPersonsKept.splice(index_k, 1);
            setSelectedPersonsKept(newSelectedPersonsKept);
        }
    };

    const APersonUnit = (props: any) => {
        let person = props.person;
        const [mouseOn, setMouseOn] = React.useState(false);
        return (
            <Tip
                plain
                dropProps={{ align: { bottom: "top" } }}
                content={
                    <Box background={{ color: "rgb(255,255,255,0.9)" }}>
                        <Text size="11px">제외하기</Text>
                    </Box>
                }
            >
                <Button
                    plain
                    hoverIndicator
                    margin={{ horizontal: "10px" }}
                    label={<Text size="15px">{person.primaryname}</Text>}
                    icon={
                        <Close size="12px" color={mouseOn ? "grey" : "white"} />
                    }
                    onMouseEnter={() => {
                        setMouseOn(true);
                    }}
                    onMouseLeave={() => {
                        setMouseOn(false);
                    }}
                    onClick={() => removeAPerson(person)}
                />
            </Tip>
        );
    };

    const ResetSelect = () => (
        <Box
            width="full"
            height="full"
            align="end"
            justify="between"
            alignSelf="end"
            direction='row'
        >
            <Text size='12px' margin={{left:"10px"}}>선택한 인물 {selectedPersonsKept.length}명</Text>
            <Button
                margin={{ horizontal: "5px" }}
                plain
                label={<Text size="12px">인물 선택 초기화</Text>}
                hoverIndicator
                onClick={() => emptyPersonsSelected()}
                disabled={selectedPersonsKept.length === 0}
            />
        </Box>
    );
    const PersonListBox = () => (
        <Box direction="row" width='full' align='center' justify='center'>
            <Box direction="column" align="center" justify="center" width='full'>
                <ResetSelect />
                <Box
                    overflow={{ vertical: "auto" }}
                    height="full"
                    width="full"
                    border
                    style={{
                        minHeight: "80px",
                        maxHeight: "80px",
                        minWidth: "180px",
                    }}
                    round="10px"
                    margin={{ vertical: "10px" }}
                    pad={{ vertical: "10px" }}
                    direction="row"
                >
                    {selectedPersonsKept.length===0?
                    <Text size="11px" margin="10px">
                        원본의 이름 오기, 한자 폰트 등의 이유로 한 인물이 여러 이름을 가질 수 있습니다.
                        여러 이름으로 검색하여 자료를 모아보세요. 새로운 이름으로 검색해도 선택한 인물은 유지됩니다.
                    </Text>:<Text margin={{ horizontal: "20px" }}>
                        {selectedPersonsKept.map((person: PersonObject) => (
                            <APersonUnit person={person} key={person.person_id}/>
                        ))}
                    </Text>}
                </Box>
            </Box>
            <SelectButton />
        </Box>
    );
    const SelectButton = () => (
        <Box margin={{top:"20px"}}
            direction="row" align="center" justify="center" style={{minWidth:"130px", maxWidth:"200px"}}>
            <Box direction="row" align="center" justify="center" margin="10px">
                <ImArrowRight size="20px" color={selectedPersonsKept.length===0? "grey": "black"}/>
            </Box>
            <Box
                style={{
                    minHeight: "50px",
                    minWidth: "50px",
                }}
                round="10px"
                align="center"
                justify="center"
                alignSelf="center"
                onClick={() => gotoPersonPage()}
                hoverIndicator={selectedPersonsKept.length > 0 ? true : false}
            >
                <Button
                    onClick={() => gotoPersonPage()}
                    disabled={selectedPersonsKept.length === 0}
                >
                    자료보기
                </Button>
            </Box>
        </Box>
    );
    const SelectOption = () => (
        <Box
            width="full"
            direction="row"
            align="start"
            justify="start"
            flex={false}
            margin={{top:"10px"}}
        >
            <Button
                hoverIndicator
                plain
                label={<Text size="15px">모두 선택 </Text>}
                onClick={() => {
                    addPersonsAll();
                }}
                margin={{ horizontal: "5px" }}
            />
            <Text size="15px" margin={{ horizontal: "10px" }}>
                |
            </Text>
            <Button
                hoverIndicator
                plain
                label={<Text size="15px">선택 해제</Text>}
                onClick={() => {
                    removePersonsAll();
                }}
                margin={{ horizontal: "5px" }}
                disabled={selectedPersons.length === 0}
            />
        </Box>
    );


    return (
        <>
            <Box
                width="full"
                alignSelf="center"
                align="center"
                justify="center"
                direction="column"
                height="full"
            >
                <PersonListBox/>
                {/* <SelectOption/> */}
            </Box>
        </>
    );
};
export default PersonSelectBox;
